import React from 'react';
import { Modal } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { createPaymentRequest } from '../../services/sell_order';
import { useCuentasPorCobrar } from '../../hooks/useCuentasPorCobrar';
import { PaymentRequestModal } from './PaymentRequestModal';
import { PaymentsHistoryModal } from './PaymentsHistoryModal';
import { CleanCuentasPorCobrarList } from './CleanCuentasPorCobrarList';

interface CuentasPorCobrarProps {
  onBack?: () => void;
}

const CuentasPorCobrar: React.FC<CuentasPorCobrarProps> = ({ onBack }) => {
  const {
    orders,
    payments,
    deuda,
    deudaNeta,
    isLoading,
    isError,
    selectedOrderId,
    paymentsOrderId,
    selectedOrder,
    paymentRequest,
    exceedsBalance,
    mutate,
    openPaymentRequest,
    closePaymentRequest,
    openPaymentsHistory,
    closePaymentsHistory,
    updatePaymentRequest,
  } = useCuentasPorCobrar();

  const handleSubmitPaymentRequest = async (
    amount: number,
    date: string,
    method: string,
    notes?: string
  ) => {
    if (!selectedOrderId) return;
    
    try {
      await createPaymentRequest(selectedOrderId, {
        amount,
        date,
        method,
        notes
      });
      
      toast.success('Solicitud enviada');
      mutate(); // Refrescar datos
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || error.message || 'Error al crear solicitud';
      toast.error(errorMessage);
      throw error; // Re-lanzar para que el modal maneje el estado
    }
  };

  if (isError) {
    return (
      <div style={{ 
        textAlign: 'center', 
        padding: '2rem', 
        color: '#dc3545',
        fontWeight: 600
      }}>
        Error al intentar traer datos del servidor
      </div>
    );
  }

  if (isLoading) {
    return (
      <div style={{ 
        textAlign: 'center', 
        padding: '2rem', 
        color: '#6c757d' 
      }}>
        Cargando datos...
      </div>
    );
  }

  return (
    <>
      <CleanCuentasPorCobrarList
        orders={orders}
        totalDebt={deuda}
        deudaNeta={deudaNeta}
        onRequestPayment={openPaymentRequest}
        onViewPayments={openPaymentsHistory}
        onBack={onBack || (() => window.history.back())}
      />

      {/* Modal: Solicitud de cobro */}
      <Modal 
        show={selectedOrderId !== null} 
        onHide={closePaymentRequest}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Registrar cobro (solicitud) - Orden Nº {selectedOrderId}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PaymentRequestModal
            selectedOrder={selectedOrder}
            paymentRequest={paymentRequest}
            exceedsBalance={exceedsBalance}
            onClose={closePaymentRequest}
            onSubmit={handleSubmitPaymentRequest}
            onUpdateRequest={updatePaymentRequest}
          />
        </Modal.Body>
      </Modal>

      {/* Modal: Historial de cobros */}
      <Modal 
        show={paymentsOrderId !== null} 
        onHide={closePaymentsHistory}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: '1.05rem', fontWeight: 600 }}>
            Cobros realizados - Orden Nº {paymentsOrderId}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PaymentsHistoryModal
            orderId={paymentsOrderId}
            payments={payments}
            onClose={closePaymentsHistory}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CuentasPorCobrar;